module.exports = __webpack_public_path__ + "e259d63adffc7aebc94b507180c08a25.svg";